

export const sendMessage = (message: any) => {

	window.parent.postMessage({
		type: 'agility.legacycustomfield',
		...message,
	}, '*')
}